export const validEmail = new RegExp('^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]$');
export const validNumber = /^(\+\d{1,3}[- ]?)?\d{10}$/;
